import { useMemo } from 'react';

import { LabelId, UserCommunication } from '@this+that/models';

import {
  UserCommunicationFilter,
  useFilterUserCommunications,
} from '../../../hooks';
import { useUserCommunicationsStore } from '../../../store';
import { InboxType } from '../types';

export interface InboxCountResult {
  count: number;
  isPartial: boolean;
}

const EMPTY_INBOX_COUNT: InboxCountResult = { count: 0, isPartial: false };

const countUnreadMainMessages = (messages: UserCommunication[]): number => {
  const uniqueByMessageId = Array.from(
    new Map(messages.map((message) => [message.messageId, message])).values(),
  );

  return uniqueByMessageId.filter((communication) => {
    const hasInboxAndUnread =
      communication.labelIds?.includes(LabelId.INBOX) &&
      communication.labelIds?.includes(LabelId.UNREAD);

    return hasInboxAndUnread;
  }).length;
};

export function useInboxCount(type: InboxType): InboxCountResult {
  const primary = useUserCommunicationsStore((state) => state.primary);
  const draft = useUserCommunicationsStore((state) => state.draft);
  const primaryStartKey = useUserCommunicationsStore(
    (state) => state.startKeys.primary,
  );
  const draftStartKey = useUserCommunicationsStore(
    (state) => state.startKeys.draft,
  );

  const { filteredCommunications: draftMessages } = useFilterUserCommunications(
    draft,
    UserCommunicationFilter.DRAFT,
  );

  const mainCount = useMemo(() => countUnreadMainMessages(primary), [primary]);

  if (type === 'main') {
    return { count: mainCount, isPartial: primaryStartKey !== null };
  }

  if (type === 'draft') {
    return {
      count: draftMessages?.length ?? 0,
      isPartial: draftStartKey !== null,
    };
  }

  return EMPTY_INBOX_COUNT;
}
